<template>
  <div>
    <van-sticky>

      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">教师管理({{ countTeacher }})</div>
        <div slot="right" @click="delAllTeacher" style="font-size: 10px;color: #ff5777;margin-right: 10px">清空所有</div>
      </nav-bar>

      <van-cell title="添加教师" size="large" is-link to="AddTeacher"/>

      <!--      <van-cell title="清空教师" @click="delAllTeacher" style="color: red;text-align: center"/>-->

      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入姓名关键词"
        @search="onSearch"
        @cancel="onCancel"
      />

    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <!--        <van-cell v-for="item in teacherList" :key="item" :title="item+'123'">-->
        <!--          <button>1</button>-->
        <!--        </van-cell>-->
        <van-swipe-cell v-for="item in teacherList" :key="item.id">
          <template slot="left">
            <van-button square type="primary" text="选择"/>
          </template>
          <van-cell :border="false" :title="item.tName+' '+item.gender+' '+item.tNum" value="<<滑动<<"/>
          <template slot="right">
            <van-button square type="danger" @click="delTeacher(item.id)" text="删除"/>
            <van-button square type="warning" @click="reset(item.id)" text="重置密码"/>
            <van-button square type="primary" @click="loginUnlock(item.tNum)" text="解锁"/>
            <!--            <van-button square type="primary" text="收藏"/>-->
          </template>
        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>


  </div>
</template>

<script>
import Vue from 'vue';
import {List, PullRefresh, Cell, SwipeCell, Button, Search, Dialog, Toast, Sticky, Pagination} from 'vant';
import {
  getTeacherList,
  getTeacherListLikeName,
  DelTeacherById,
  DelAllTeacher,
  ResetTeacherPassword
} from "network/teacher";
import {
  LoginUnlock
} from "@/network/publics";
import NavBar from "components/common/navbar/NavBar";

Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Cell);
Vue.use(SwipeCell);
Vue.use(Button);
Vue.use(Search);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Sticky);
Vue.use(Pagination);
export default {
  name: "Tealist",
  components: {
    NavBar
  },
  data() {
    return {
      teacherList: [],
      loading: false,
      finished: true,
      refreshing: false,
      searchValue: '',

      // count teacher
      countTeacher: 0,

    };
  },
  created() {
    this.getTeacherList();
  },
  methods: {
    onSearch(val) {
      this.getTeacherListLikeName(this.searchValue);
    },
    onCancel() {
      this.getTeacherListLikeName("");
    },
    // arrangement(res){
    //   let max=-1;
    //   for (let i=0;i<res.length;i++){
    //     if (res[i].tecname.length>max){
    //       max=res[i].tecname.length;
    //     }
    //   }
    //   for (let i=0;i<res.length;i++){
    //       let add=max-res[i].tecname.length;
    //       let s='';
    //       for (let i=0;i<add;i++){
    //         s=s+"";
    //       }
    //       res[i].tecname=s+res[i].tecname;
    //   }
    //   console.log(max);
    //   return res;
    // },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.refreshing = false;
          this.finished = true
        }
        this.getTeacherList();
        //this.loading = false;

        // if (this.teacherList.length >= 40) {
        //   this.finished = true;
        // }
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
    },
    getTeacherList() {
      getTeacherList().then(res => {
        this.teacherList = res;
        this.countTeacher = res.length;
      });
    },
    getTeacherListLikeName(name) {
      getTeacherListLikeName(name).then(res => {
        this.teacherList = res;
        this.countTeacher = res.length;
      });
    },
    delTeacher(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelTeacherById(id).then(res => {
            if (res) {
              this.teacherList = this.teacherList.filter(item => item.id != id);
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    delAllTeacher() {
      Dialog.confirm({
        title: '警告',
        message: '确定要删除所有教师吗'
      }).then(() => {
        DelAllTeacher().then(res => {
          if (res) {
            this.teacherList = [];
            Toast.success('刪除成功');
          } else {
            Toast.fail('删除失败');
          }
        });
      }).catch(() => {
        Toast.fail('删除失败');
      });
    },
    reset(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要重置为123456吗'
      }).then(() => {
        ResetTeacherPassword(id).then(res => {
            if (res) {
              Toast.success('重置成功');
            } else {
              Toast.fail('重置失败');
            }
          }
        ).catch(res => {
          Toast.fail('重置失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });

    },
    loginUnlock(tNum) {
      console.log(tNum)
      Dialog.confirm({
        title: '提示',
        message: '确定要解锁吗'
      }).then(() => {
        LoginUnlock(tNum).then(res => {
          if (res) {
            Toast.success('解锁成功');
          } else {
            Toast.fail('解锁失败');
          }
        })
        // on confirm
      })
    },
    onClickLeft() {
      this.$router.replace("/home");
    }
  }
}
</script>

<style scoped>
.home-nav {
  background-color: var(--color-tint);
  color: #fff;
}

</style>
